module.exports = __webpack_public_path__ + "img/Noodles-and-company_logo.8e9748c3.svg";